define('plugin/product/collection/ProductCollection',['require','lib/collection/BaseCollection','plugin/product/model/ProductModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var ProductModel = require('plugin/product/model/ProductModel');

    return BaseCollection.extend({

        url: '/ext/product/',
        model: ProductModel

    });

});
